import React from 'react';
import { Check } from 'react-feather';
import PropTypes from 'prop-types';

import { StyledLabel, HiddenCheckbox, StyledCheckbox, StyledCheckboxContainer } from './Checkbox.styles';

const Checkbox = ({ onChange, checked, disabled, label, dataCy, className, name }) => (
  <StyledCheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} disabled={disabled} data-testid={dataCy} onChange={(e) => onChange(e.target.checked)} name={name} />
    <StyledCheckbox
      aria-checked={checked}
      checked={checked}
      data-testid={`${dataCy}--no-hidden`}
      className="checkbox"
      data-cy={dataCy}
      disabled={disabled}
      role="checkbox"
    >
      {checked && <Check />}
    </StyledCheckbox>
    <StyledLabel bold={checked}>{label}</StyledLabel>
  </StyledCheckboxContainer>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func
};

export default Checkbox;
